import Modal from "@common/Modal";
import { useEffect } from "react";

const AddApplicationThankPopupID = (props: any) => {
    const { show, screenType, handleClose } = props;

    useEffect(() => {
        if (show) {
            document.body.classList.add("overflow-hidden");
        }
        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [show]);

    return (
        <div className="model-outer upload-success-popupID">
            <Modal
                show={show}
                handleClose={handleClose}
                screenType={screenType}
            >
                <div className="modal-body">
                    <div className="upload-success-msg">

                        {/* Icon */}
                        <div className="check-icn success-green">
                            <i className="ic-check"></i>
                        </div>

                        {/* Main text */}
                        {(
                            <>
                                <span className="thanks-txt">
                                    We have register your request to delete account successfully
                                </span>

                                <div className="id-number">
                                    The relevant manager will contact you shortly to
                                    address your concern further
                                </div>
                            </>
                        ) }
                    </div>
                </div>
               
            </Modal>
        </div>
    );
};

export default AddApplicationThankPopupID;
